import React from 'react';
import { Tag } from 'antd';

import {
  ApprovalDecision,
  BypassState,
  WindowStatus,
} from '@totem/components/maintenanceWindowsV2/types';
import {
  BYPASS_LABELS,
  DECISION_LABELS,
  STATUS_LABELS,
} from '@totem/components/maintenanceWindowsV2/utilities';

// antd preset tag colors follow the light/dark theme.
const STATUS_COLORS: Record<WindowStatus, string> = {
  active: 'processing',
  overdue: 'error',
  awaitingApproval: 'warning',
  bypassRejected: 'error',
  scheduled: 'success',
  closed: 'default',
};

const BYPASS_COLORS: Record<BypassState, string> = {
  notRequired: 'default',
  pending: 'warning',
  rejected: 'error',
  approved: 'success',
  open: 'processing',
  notCreated: 'error',
  notRemoved: 'error',
  closed: 'default',
};

const DECISION_COLORS: Record<ApprovalDecision, string> = {
  pending: 'warning',
  approved: 'success',
  autoApproved: 'success',
  rejected: 'error',
  notRequired: 'default',
};

export const StatusTag = ({ status }: { status: WindowStatus }) => (
  <Tag color={STATUS_COLORS[status]} style={{ marginInlineEnd: 0 }}>
    {STATUS_LABELS[status]}
  </Tag>
);

export const BypassTag = ({ state }: { state: BypassState }) => (
  <Tag color={BYPASS_COLORS[state]} style={{ marginInlineEnd: 0 }}>
    {BYPASS_LABELS[state]}
  </Tag>
);

export const DecisionTag = ({ decision }: { decision: ApprovalDecision }) => (
  <Tag color={DECISION_COLORS[decision]} style={{ marginInlineEnd: 0 }}>
    {DECISION_LABELS[decision]}
  </Tag>
);
